export default __webpack_public_path__ + "static/media/20.85f66e6e.jpg";